// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useCallback, useMemo, useState } from "react";
import { Button, Card, Row, Typography } from "antd";
import { RateNegotiationConfigEnum } from "src/components/RateNegotiationModal/interfaces";
import { EMPLOYEE_ROLES } from "@src/appV2/Employee/constants";
import { EditStatusModal } from "./EditStatusModal";
import { Facility } from "src/interface";
import { useSupportLink } from "@src/appV2/HelpCenter/useSupportLinks";

const { Text } = Typography;

interface IRateNegotiationStatusCard {
  isAdmin?: boolean;
  facility: {
    rateNegotiation?: RateNegotiationConfigEnum;
    userId?: string;
    name?: string;
    fullAddress?: Facility["fullAddress"];
  };
  roles?: string[];
  updateFacilityData: (data: { rateNegotiation: RateNegotiationConfigEnum }) => Promise<void>;
}

function RateNegotiationStatusCard({
  // FIXME: Automatically disabled during ESLint config update
  // @ts-expect-error TODO(typecheck-unify): TS6133 'isAdmin' is declared but its value is never read.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isAdmin = false,
  facility,
  roles,
  updateFacilityData,
}: IRateNegotiationStatusCard) {
  const learnMoreLink = useSupportLink("RATE_NEGOTIATION_ADMIN");
  const editButtonVisible = useMemo(() => roles?.includes(EMPLOYEE_ROLES.SHIFT_PRICING), [roles]);
  const [editModalVisible, setEditModalVisible] = useState<boolean>(false);
  const TitleComponent = useMemo(
    () => (
      <Row>
        <Text data-testid="rate-negotiation-status-card-title-text">
          Rate Negotiation Status: {facility.rateNegotiation === "ON" ? "ON" : "OFF"}
        </Text>
      </Row>
    ),
    [facility.rateNegotiation]
  );
  const editRateNegotiationStatus = useCallback(() => {
    setEditModalVisible(true);
  }, []);

  return (
    <>
      <Card
        title={TitleComponent}
        extra={
          editButtonVisible && (
            <Button
              data-testid="rate-negotiation-status-card-edit-button"
              type="link"
              onClick={editRateNegotiationStatus}
            >
              Edit
            </Button>
          )
        }
      >
        <a style={{ paddingLeft: 12 }} href={learnMoreLink} target="_blank">
          Click to learn more about what this means
        </a>
      </Card>
      {facility.userId && (
        <EditStatusModal
          visible={editModalVisible}
          title={TitleComponent}
          setVisibility={setEditModalVisible}
          currentStatus={facility.rateNegotiation}
          updateFacilityData={updateFacilityData}
          facilityId={facility.userId}
        />
      )}
    </>
  );
}

export { RateNegotiationStatusCard };
